import { createContext, useContext } from 'react';
export const ActionsContext = /*#__PURE__*/createContext({
  statuses: {},
  siteInfo: {
    externalViewer: false
  },
  handlers: {},
  enabledActions: [],
  uiConfig: {}
});
export const useStatuses = () => {
  const _useContext = useContext(ActionsContext),
    statuses = _useContext.statuses;
  if (!statuses) {
    throw new Error('useStatuses must be used within an ActionsExtension Provider');
  }
  return statuses;
};
export const useSiteInfo = () => {
  const _useContext2 = useContext(ActionsContext),
    siteInfo = _useContext2.siteInfo;
  if (!siteInfo) {
    throw new Error('useSiteInfo must be used within an ActionsExtension Provider');
  }
  return siteInfo;
};
export const useUiConfig = () => {
  const _useContext3 = useContext(ActionsContext),
    uiConfig = _useContext3.uiConfig;
  return uiConfig;
};
export const useActionHandlers = () => {
  const _useContext4 = useContext(ActionsContext),
    handlers = _useContext4.handlers;
  if (!handlers) {
    throw new Error('useActionHandlers must be used within an ActionsExtension Provider');
  }
  return handlers;
};
export const useEnabledActions = () => {
  const _useContext5 = useContext(ActionsContext),
    enabledActions = _useContext5.enabledActions;
  if (!enabledActions) {
    throw new Error('useEnabledActions must be used within an ActionsExtension Provider');
  }
  return enabledActions;
};
export const useAutoInvokeOverride = () => {
  const _useContext6 = useContext(ActionsContext),
    autoInvokeOverride = _useContext6.autoInvokeOverride;
  return autoInvokeOverride;
};
export const useResolveCorrectedDomains = () => {
  const _useContext7 = useContext(ActionsContext),
    resolveCorrectedDomains = _useContext7.resolveCorrectedDomains;
  return resolveCorrectedDomains;
};
//# sourceMappingURL=context.js.map